package ir.alirezaivaz.finglish.dto

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.runtime.Composable
import finglish.composeapp.generated.resources.Res
import finglish.composeapp.generated.resources.ic_brightness_medium
import finglish.composeapp.generated.resources.ic_dark_mode
import finglish.composeapp.generated.resources.ic_dark_mode_filled
import finglish.composeapp.generated.resources.ic_light_mode
import finglish.composeapp.generated.resources.ic_light_mode_filled
import finglish.composeapp.generated.resources.settings_theme_day
import finglish.composeapp.generated.resources.settings_theme_night
import finglish.composeapp.generated.resources.settings_theme_system
import ir.alirezaivaz.finglish.utils.Utils
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource

enum class Theme(
    val icon: DrawableResource,
    val iconFilled: DrawableResource,
    val title: StringResource,
    val isAvailable: Boolean = true
) {
    Day(
        icon = Res.drawable.ic_light_mode,
        iconFilled = Res.drawable.ic_light_mode_filled,
        title = Res.string.settings_theme_day,
    ),
    Night(
        icon = Res.drawable.ic_dark_mode,
        iconFilled = Res.drawable.ic_dark_mode_filled,
        title = Res.string.settings_theme_night,
    ),
    System(
        icon = Res.drawable.ic_brightness_medium,
        iconFilled = Res.drawable.ic_brightness_medium,
        title = Res.string.settings_theme_system,
        isAvailable = Utils.isSystemNightModeSupported()
    );

    companion object {
        fun find(value: String): Theme = entries.find { it.name == value } ?: getDefaultTheme()
        fun getDefaultTheme(): Theme = System.takeIf { Utils.isSystemNightModeSupported() } ?: Day
    }
}

@Composable
fun Theme.isDarkMode(): Boolean {
    return this == Theme.Night || (this == Theme.System && isSystemInDarkTheme())
}
